<a
  *ngIf="isButton"
  (click)="contactSupport()"
  (keydown.enter)="contactSupport()"
  class="ds-button btn-block ds-button--primary"
  class="focusable focusable__element"
  tabindex="0"
  data-cy="contactSupportButtonInContactUsScenario"
  [innerText]="buttonText | cxTranslate"></a>

<udex-link *ngIf="!isButton" (click)="contactSupport()" data-cy="contactSupportButtonInContactUsScenario">
  {{ buttonText | cxTranslate }}
</udex-link>

<ds-modal
  [modalIsActive]="isContactModalOpen"
  [modalHeader]="'productDetails.contactSupport' | cxTranslate"
  (canBeClosed)="isContactModalOpen = false">
  <dcp-contact-iframe [iFrameTitle]="'productDetails.contactSupport' | cxTranslate"></dcp-contact-iframe>
</ds-modal>
